export default "__VITE_ASSET__1778c0af__"